var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.056 18.333q-.579 0-.984-.396a1.3 1.3 0 0 1-.405-.963v-1.721l3.704-3.217v6.297zm3.24 0V14.71h7.408v3.624zm8.334 0v-7.43l-3.958-3.442 2.8-2.424 4.399 3.828q.231.203.347.464t.116.555v7.09q0 .567-.405.963t-.984.396zM1.667 14.03V9.884q0-.294.116-.566t.347-.453L9.074 2.84q.186-.182.429-.26a1.6 1.6 0 0 1 .995 0q.243.078.428.26l1.852 1.608z"
  })));
};
export default SvgLogo;